import Card from "./Card";
import { useId, useState } from "react";
import { useComparison } from "../hooks/useComparison";
import MovieSwap from "./MovieSwap";

const MovieSwapPage = () => {
  const { usernames } = useComparison();
  const [selectedUser1, setSelectedUser1] = useState<string>("");
  const [selectedUser2, setSelectedUser2] = useState<string>("");
  const user1Id = useId();
  const user2Id = useId();

  const labelFor = (username: string) =>
    usernames.find((u) => u.username === username)?.displayName || username;

  return (
    <div>
      <h1 className="text-3xl font-bold text-letterboxd-text-primary mb-2">
        Movie Swap
      </h1>
      <h3 className="subheading">
        Find films each user has rated that the other hasn't seen
      </h3>
      <Card className="mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="select-wrapper">
            {/* sr-only is position:absolute, so it cannot disturb the
             * wrapper's ::after arrow. Text matches the placeholder (2.5.3). */}
            <label htmlFor={user1Id} className="sr-only">
              Select User 1
            </label>
            <select
              id={user1Id}
              value={selectedUser1}
              onChange={(e) => setSelectedUser1(e.target.value)}
              className="input-field w-full"
            >
              <option value="">Select User 1</option>
              {usernames.map((user) => (
                <option key={user.username} value={user.username}>
                  {user.displayName || user.username}
                </option>
              ))}
            </select>
          </div>
          <div className="select-wrapper">
            <label htmlFor={user2Id} className="sr-only">
              Select User 2
            </label>
            <select
              id={user2Id}
              value={selectedUser2}
              onChange={(e) => setSelectedUser2(e.target.value)}
              className="input-field w-full"
            >
              <option value="">Select User 2</option>
              {usernames.map((user) => (
                <option key={user.username} value={user.username}>
                  {user.displayName || user.username}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Card>

      {selectedUser1 && selectedUser2 && selectedUser1 !== selectedUser2 && (
        <MovieSwap
          user1={selectedUser1}
          user2={selectedUser2}
          user1Label={labelFor(selectedUser1)}
          user2Label={labelFor(selectedUser2)}
        />
      )}
    </div>
  );
};

export default MovieSwapPage;
